import QUERY_KEYS from '@/constants/query-keys';
import api from '@/lib/api';

interface KhaiBaoThongTinTSCDResponse<T = any> {
  results: T[];
  count: number;
  next: string | null;
  previous: string | null;
}

export const fetchAllKhaiBaoThongTinTSCD = async (
  entitySlug: string,
  params: Record<string, any> = {},
  pageSize = 200
): Promise<any[]> => {
  let page = 1;
  let all: any[] = [];

  while (true) {
    const response = await api.get<KhaiBaoThongTinTSCDResponse>(
      `/entities/${entitySlug}/erp/${QUERY_KEYS.KHAI_BAO_THONG_TIN_TSCD}/`,
      {
        params: {
          ...params,
          page,
          page_size: pageSize
        }
      }
    );

    const pageResults = response.data.results || [];
    all = all.concat(pageResults);

    // Nếu không còn trang tiếp theo thì dừng
    if (!response.data.next) {
      break;
    }

    page += 1;
  }

  return all;
};
